import moment from "moment";
import { GLOBAL_STATUS } from "../../../constants/common";;

export const EVENT_TYPES = [
    { value: "evaluation", label: "Avaliação" },
    { value: "test", label: "Teste" },
    { value: "extra", label: "Evento Extra" },
];

export const TEST_TYPES = [
    { value: "fixed_time", label: "Tempo Fixo" },
    { value: "fixed_distance", label: "Distância Fixa" },
];


export const getEventStatus = (event) => {
    if (!event.startDate || !event.endDate) return GLOBAL_STATUS.INACTIVE;
    const now = moment().startOf('day');
    const start = moment(event.startDate).startOf('day');
    const end = moment(event.endDate).startOf('day');
    
    if (now.isBetween(start, end, null, '[]')) {
        return GLOBAL_STATUS.ACTIVE;
    }
    return GLOBAL_STATUS.INACTIVE;
};
